import { render, staticRenderFns } from "./skeleton-box.vue?vue&type=template&id=2185db5c&"
import script from "./skeleton-box.vue?vue&type=script&lang=js&"
export * from "./skeleton-box.vue?vue&type=script&lang=js&"
import style0 from "./skeleton-box.vue?vue&type=style&index=0&id=2185db5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports